export const countryOptions = [
  { code: '+1', label: '🇺🇸' }, // United States
  { code: '+44', label: '🇬🇧' }, // United Kingdom
  { code: '+33', label: '🇫🇷' }, // France
  { code: '+49', label: '🇩🇪' }, // Germany
  { code: '+34', label: '🇪🇸' }, // Spain
  { code: '+61', label: '🇦🇺' }, // Australia
  { code: '+91', label: '🇮🇳' }, // India
  { code: '+81', label: '🇯🇵' }, // Japan
  { code: '+39', label: '🇮🇹' }, // Italy
  { code: '+86', label: '🇨🇳' }, // China
  { code: '+55', label: '🇧🇷' }, // Brazil
  { code: '+7', label: '🇷🇺' }, // Russia
  { code: '+52', label: '🇲🇽' }, // Mexico
  { code: '+46', label: '🇸🇪' }, // Sweden
  { code: '+47', label: '🇳🇴' }, // Norway
  { code: '+358', label: '🇫🇮' }, // Finland
  { code: '+41', label: '🇨🇭' }, // Switzerland
  { code: '+31', label: '🇳🇱' }, // Netherlands
  { code: '+32', label: '🇧🇪' }, // Belgium
  { code: '+30', label: '🇬🇷' }, // Greece
  { code: '+20', label: '🇪🇬' }, // Egypt
  { code: '+63', label: '🇵🇭' }, // Philippines
  { code: '+65', label: '🇸🇬' }, // Singapore
  { code: '+60', label: '🇲🇾' }, // Malaysia
  { code: '+64', label: '🇳🇿' }, // New Zealand
  { code: '+94', label: '🇱🇰' }, // Sri Lanka
  { code: '+82', label: '🇰🇷' }, // South Korea
  { code: '+53', label: '🇨🇺' }, // Cuba
  { code: '+1 242', label: '🇧🇸' }, // Bahamas
  { code: '+1 246', label: '🇧🇧' }, // Barbados
  { code: '+45', label: '🇩🇰' }, // Denmark
  { code: '+353', label: '🇮🇪' }, // Ireland
  { code: '+972', label: '🇮🇱' }, // Israel
  { code: '+966', label: '🇸🇦' }, // Saudi Arabia
  { code: '+971', label: '🇦🇪' }, // United Arab Emirates
  { code: '+92', label: '🇵🇰' }, // Pakistan
  { code: '+98', label: '🇮🇷' }, // Iran
  { code: '+507', label: '🇵🇦' }, // Panama
  { code: '+57', label: '🇨🇴' }, // Colombia
  { code: '+56', label: '🇨🇱' }, // Chile
  { code: '+51', label: '🇵🇪' }, // Peru
  { code: '+48', label: '🇵🇱' }, // Poland
  { code: '+43', label: '🇦🇹' }, // Austria
  { code: '+36', label: '🇭🇺' }, // Hungary
  { code: '+40', label: '🇷🇴' }, // Romania
  { code: '+380', label: '🇺🇦' }, // Ukraine
  { code: '+27', label: '🇿🇦' }, // South Africa
  { code: '+233', label: '🇬🇭' }, // Ghana
  { code: '+254', label: '🇰🇪' }, // Kenya
  { code: '+234', label: '🇳🇬' }, // Nigeria
  { code: '+61 8', label: '🇦🇺' }, // Australia (Western Australia)
  { code: '+47 79', label: '🇳🇴' }, // Svalbard (Norway)
  { code: '+1 441', label: '🇧🇲' }, // Bermuda
  { code: '+30 21', label: '🇬🇷' }, // Greece (Athens)
  { code: '+45 2', label: '🇩🇰' }, // Denmark (Copenhagen)
  { code: '+64 3', label: '🇳🇿' }, // New Zealand (South Island)
  { code: '+1 473', label: '🇬🇩' }, // Grenada
  { code: '+1 876', label: '🇯🇲' }, // Jamaica
  { code: '+52 55', label: '🇲🇽' }, // Mexico City
];
